
<template>
  <div class="toCheck_box">
    <!-- 检测报告 -->
    <div class="check_box">
      <div class="head_bg">
        <div class="flex">
          <p>{{userInfo.name}}</p>
          <div class="score">{{blackInfo.grade}}分
            <p :class="{'score_img1':blackInfo.grade<=50,'score_img2':blackInfo.grade<=65&&blackInfo.grade>50,'score_img3':blackInfo.grade<=90&&blackInfo.grade>65,'score_img4':blackInfo.grade>90}"></p>
          </div>
        </div>
        <div class="userInfo">
          <ul>
            <li>
              <p class="userkey">手机号码:</p>
              <p class="userValue">{{userInfo.mobile?util.checkPhone(userInfo.mobile):''}}</p>
            </li>
            <li>
              <p class="userkey">身份证号:</p>
              <p class="userValue">{{userInfo.idCard?util.checkIdCard(userInfo.idCard,6,4):''}}</p>
            </li>
            <li>
              <p class="userkey">查询时间:</p>
              <p class="userValue">{{userInfo.gmtCreated?userInfo.gmtCreated.substr(0,10):''}}</p>
            </li>
          </ul>
        </div>
      </div>
      <div class="item">
        数据来源第三方机构，帮用户检测信息安全和了解借贷问题<br><span class="color_bg">建议15天检测一次，维护个人信用，借钱从此无忧</span>
      </div>
      <!-- 个人信用评估 -->
      <div class="item">
        <p class="comn_title1"></p>
        <div class="item_con">
          <div class="per_con">
            <div class="left_box">
              <span class="per_icon1"></span>
              <div class="ps">
                <p class="title">{{checkGrade(blackInfo.grade)}}</p>
                <p>综合评级</p>
              </div>
            </div>
            <div class="right_box">
              <span class="per_icon2"></span>
              <div class="ps">
                <p class="title">{{checkLevel(blackInfo.grade)}}</p>
                <p>信用额度</p>
              </div>
            </div>
          </div>
          <div class="progress_bg">
            <span class="progress_icon"
                  :class="{'pr_32':blackInfo.grade<=65&&blackInfo.grade>50,'pr_58':blackInfo.grade<=90&&blackInfo.grade>65,'score_img4':blackInfo.grade>90}"></span>
          </div>
          <!-- <Echarts2 :dataList1="dataList2"></Echarts2> -->
          <div class="item_info">
            解读：<br>
            1、近期偏好网贷，借贷行为没有较大的变化趋势，多数借贷会有人工介入审核。<br>
            2、建议在完善资料信息时，信息必须真实准确，尽可能完善自己的财产信息，借款方会根据借款人的财产能力给借款人提升额度。<br>
          </div>
        </div>
      </div>
      <!-- 黑名单风险 -->
      <div class="item">
        <p class="comn_title2"></p>
        <div class="item_con">
          <div class="flex_box bg">
            <div class="flex bg2">
              <p class="item_key"><span class="icon"
                      :class="{'icon1':blackInfo.finalDecision}"></span>风险黑名单</p>
              <p class="item_value"
                 :class="{'item_value_red':blackInfo.finalDecision}">{{changeStatus(blackInfo.finalDecision)}}</p>
            </div>
          </div>
        </div>
        <div class="item_info">
          解读：通过科学的模型推算，分析用户的借贷习惯、借贷偏好、借贷趋势等行为特征。若集中在一段时间内密集贷款，是贷款的活跃用户，存在被拒风险，请尽量控制申请频率。
        </div>
      </div>
      <!-- 多头借贷分析 -->
      <div class="item">
        <p class="comn_title3"></p>
        <div class="box">
          <div class="noData_box"
               v-if="!isShowEchart">
            <span class="noData1"></span>
          </div>

          <Echarts :dataList="dataList"
                   :isSpecial="isSpecial"
                   v-else></Echarts>
          <div class="box_con">
            <p><span class="squire"></span>网贷机构申请 <span class="appColor"
                    :class="{'red':blackInfo.strcutrueApply>0}">{{blackInfo.strcutrueApply}}</span> 次</p>
            <p><span class="squire1"></span>消费金融申请 <span class="appColor"
                    :class="{'red':blackInfo.expenseApply>0}">{{blackInfo.expenseApply}}</span> 次</p>
          </div>
        </div>
        <div class="item_info">
          解读：<br>
          1、此结果仅统计12个月的数据。<br>
          2、多头借贷，指借款人向多家金融机构提出借贷需求的行为。因借款人的偿还能力有限，向多方借贷可能蕴含着较高的还款风险。<br>
          3、资金需求过高时，借贷也不要逾期欠款，否则会影响信用。
        </div>
      </div>
      <!-- 借贷行为分析 -->
      <div class="item">
        <p class="comn_title4"></p>
        <div class="item_con">
          <div class="flex_box bg">
            <div class="flex bg2">
              <p class="item_key"><span class="icon"
                      :class="{'icon1':blackInfo.ruleNameCAE005}"></span>在小贷机构申请极为频繁</p>
              <p class="item_value"
                 :class="{'item_value_red':blackInfo.ruleNameCAE005}">{{changeStatus(blackInfo.ruleNameCAE005)}}</p>
            </div>
            <div class="flex bg1">
              <p class="item_key"><span class="icon"
                      :class="{'icon1':blackInfo.ruleNameCAE006}"></span>在网络小贷机构申请极为频繁</p>
              <p class="item_value"
                 :class="{'item_value_red':blackInfo.ruleNameCAE006}">{{changeStatus(blackInfo.ruleNameCAE006)}}</p>
            </div>
            <div class="flex bg2">
              <p class="item_key"><span class="icon"
                      :class="{'icon1':blackInfo.ruleNameCAE007}"></span>在消费金融机构申请极为频繁</p>
              <p class="item_value"
                 :class="{'item_value_red':blackInfo.ruleNameCAE007}">{{changeStatus(blackInfo.ruleNameCAE007)}}</p>
            </div>
            <div class="flex bg1">
              <p class="item_key"><span class="icon"
                      :class="{'icon1':blackInfo.ruleNameCAE014}"></span>申请线下消费分期极为频繁</p>
              <p class="item_value"
                 :class="{'item_value_red':blackInfo.ruleNameCAE014}">{{changeStatus(blackInfo.ruleNameCAE014)}}</p>
            </div>
            <div class="flex bg2">
              <p class="item_key"><span class="icon"
                      :class="{'icon1':blackInfo.ruleNameCAE015}"></span>申请线上现金分期极为频繁</p>
              <p class="item_value"
                 :class="{'item_value_red':blackInfo.ruleNameCAE015}">{{changeStatus(blackInfo.ruleNameCAE015)}}</p>
            </div>
            <div class="flex bg1">
              <p class="item_key"><span class="icon"
                      :class="{'icon1':blackInfo.ruleNameCAE017}"></span>申请信用卡极为频繁</p>
              <p class="item_value"
                 :class="{'item_value_red':blackInfo.ruleNameCAE017}">{{changeStatus(blackInfo.ruleNameCAE017)}}</p>
            </div>
          </div>
          <div class="progres">
            <div class="pro_item prg_bg">
              <span class="title">需求程度</span>
              <Progress style="width:65%;"
                        :percent="blackInfo.demand"
                        hide-info></Progress>
              <span class="grade">{{blackInfo.demand}}分</span>
            </div>
            <div class="pro_item prg_bg1">
              <span class="title">集中程度</span>
              <Progress style="width:65%;"
                        :percent="blackInfo.focus"
                        hide-info></Progress>
              <span class="grade1">{{blackInfo.focus}}分</span>
            </div>
            <div class="pro_item prg_bg2">
              <span class="title">活跃程度</span>
              <Progress style="width:65%;"
                        :percent="blackInfo.active"
                        hide-info></Progress>
              <span class="grade2">{{blackInfo.active}}分</span>
            </div>
          </div>
          <div class="item_info">
            解读：通过科学的模型推算，分析用户的借贷习惯、借贷偏好、借贷趋势等行为特征。若集中在一段时间内密集贷款，是贷款的活跃用户，存在被拒风险，请尽量控制申请频率。
          </div>
        </div>
      </div>
      <div class="item">
        <p class="comn_title5"></p>
        <div class="item_con">
          <div class="flex_box bg">
            <div class="flex bg2">
              <p class="item_key"><span class="icon"
                      :class="{'icon1':financialIndustry.bankMoneyType}"></span>银行类金融机构风险</p>
              <p class="item_value"
                 :class="{'item_value_red':financialIndustry.bankMoneyType}">{{changeStatus(financialIndustry.bankMoneyType)}}</p>
            </div>
            <div class="flex bg1">
              <p class="item_key"><span class="icon"
                      :class="{'icon1':financialIndustry.smallLoans}"></span>挂牌小贷机构风险</p>
              <p class="item_value"
                 :class="{'item_value_red':financialIndustry.smallLoans}">{{changeStatus(financialIndustry.smallLoans)}}</p>
            </div>
            <div class="flex bg2">
              <p class="item_key"><span class="icon"
                      :class="{'icon1':financialIndustry.netCredit}"></span>挂牌网贷机构风险</p>
              <p class="item_value"
                 :class="{'item_value_red':financialIndustry.netCredit}">{{changeStatus(financialIndustry.netCredit)}}</p>
            </div>
            <div class="flex bg1">
              <p class="item_key"><span class="icon"
                      :class="{'icon1':financialIndustry.consumerFinance}"></span>非银行类金融机构风险</p>
              <p class="item_value"
                 :class="{'item_value_red':financialIndustry.consumerFinance}">{{changeStatus(financialIndustry.consumerFinance)}}</p>
            </div>
            <div class="flex bg2">
              <p class="item_key"><span class="icon"
                      :class="{'icon1':financialIndustry.financingLease}"></span>持牌融资租赁风险</p>
              <p class="item_value"
                 :class="{'item_value_red':financialIndustry.financingLease}">{{changeStatus(financialIndustry.financingLease)}}</p>
            </div>
            <div class="flex bg1">
              <p class="item_key"><span class="icon"
                      :class="{'icon1':financialIndustry.carMoney}"></span>持牌汽车金融风险</p>
              <p class="item_value"
                 :class="{'item_value_red':financialIndustry.carMoney}">{{changeStatus(financialIndustry.carMoney)}}</p>
            </div>
          </div>
          <div class="item_info">
            解读：<br>
            1、风险信息扫描主要针对过往的行为进行评估，主要体现在曾经有过不良行为，包括但不限于网络贷款、银行贷款、助学贷款、行业金融未支付等。<br>
            2、请不要使用非正规手段恶意刷单、薅羊毛。<br>
            3、请端正思想，不要恶意套现或盗用他人信息。<br>
            4、请不要随意泄露个人信息，尤其是不明身份来源，谨防信息被盗用！<br>
          </div>
        </div>
      </div>
      <div class="item">
        <p class="comn_title6"></p>
        <Echarts1 :dataList1="dataList1"></Echarts1>
        <div class="item_con">
          <div class="flex_box bg">
            <div class="flex bg2">
              <p class="item_key"><span class="icon"
                      :class="{'icon1':proseInformation.idCourtBad}"></span>法院失信名单</p>
              <p class="item_value"
                 :class="{'item_value_red':proseInformation.idCourtBad}">{{changeStatus(proseInformation.idCourtBad)}}</p>
            </div>
            <div class="flex bg1">
              <p class="item_key"><span class="icon"
                      :class="{'icon1':proseInformation.idCourtExecuted}"></span>法院被执行人</p>
              <p class="item_value"
                 :class="{'item_value_red':proseInformation.idCourtExecuted}">{{changeStatus(proseInformation.idCourtExecuted)}}</p>
            </div>
            <div class="flex bg2">
              <p class="item_key"><span class="icon"
                      :class="{'icon1':proseInformation.badInfo}"></span>公安信息异常</p>
              <p class="item_value"
                 :class="{'item_value_red':proseInformation.badInfo}">{{changeStatus(proseInformation.badInfo)}}</p>
            </div>
          </div>
          <div class="item_info">
            解读：<br>
            1、失信信息、司法案例等公检信息是衡量可否借贷的重要依据。<br>
            2、不要以身试险，不要触碰法律及道德底线，如有不良行为，请及时改正。<br>
          </div>
        </div>
      </div>
      <div class="item">
        <p class="comn_title7"></p>
        <div class="item_con">
          <div class="item_notice">
            1、风险信用评估报告是由用户本人授权查询。<br>
            2、报告内容以第三方平台数据为依据，报告仅供参考，据此作出的决策均为用户独立的判断，产生的一切结果均由用户独立承担，77信用不承担任何责任。
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import PayToast from '@/components/payToast';
import Echarts from '@/components/echarts'
import Echarts1 from '@/components/echarts1'
import Echarts2 from '@/components/echarts2'
export default {
  components: {
    // Head,
    Echarts,
    Echarts1,
    Echarts2,
    PayToast
  },
  data () {
    return {
      isSpecial: 1,
      dataList: [
        { value: 0, name: '网贷机构申请' },
        { value: 0, name: '消费金融申请' },
      ],
      dataList1: [
        { value: 0, name: '社会风险等级' },
      ],
      dataList2: [10, 130, 320, 450],
      eventKey: 'h5_blacklist_view',
      userInfo: {
        mobile: '',
        idCard: '',
        gmtCreated: ''
      },
      score: 0,//是否可以检测
      blackInfo: {
        balckInfo: {
          strcutrueApply: 0,
          expenseApply: 0,
        }
      },//借贷信息
      isShowEchart: true,
      financialIndustry: {},//金融信息
      proseInformation: {},//公检信息
    }
  },
  mounted () {
    this.util.title('个人信用评估');
    this.getHitInfo();//获取检测信息
  },
  beforeDestroy () {
    clearInterval(this.timer);
    this.timer = null;
  },
  methods: {
    checkGrade (val) {
      if (val < 50) {
        return '信用极差'
      } else if (val <= 65 && val > 50) {
        return '信用一般'
      } else if (val <= 90 && val > 65) {
        return '信用良好'
      } else if (val > 90) {
        return '信用优秀'
      }
    },
    checkLevel (val) {
      if (val < 50) {
        return '非常低'
      } else if (val <= 65 && val > 50) {
        return '较低'
      } else if (val <= 90 && val > 65) {
        return '平均水平'
      } else if (val > 90) {
        return '较高'
      }
    },
    getHitInfo () {
      let _this = this;
      this.$get('/app/h5/blackList/newHitInfo')
        .then(res => {
          var e = res;
          if (e.code == 200) {
            _this.userInfo = e.data.byConsumerId;
            _this.blackInfo = e.data.blackInfo.blackInfo;
            _this.financialIndustry = e.data.blackInfo.financialIndustry;
            _this.proseInformation = e.data.blackInfo.proseInformation;
            _this.dataList[0].value = e.data.blackInfo.blackInfo.strcutrueApply;
            _this.dataList[1].value = e.data.blackInfo.blackInfo.expenseApply;
            if (_this.proseInformation.idCourtBad || _this.proseInformation.idCourtExecuted) {//高风险
              _this.dataList1 = [{ value: 90, name: '社会风险等级' }]
            } else if (_this.proseInformation.badInfo) {//中风险
              _this.dataList1 = [{ value: 60, name: '社会风险等级' }]
            } else if (!_this.proseInformation.idCourtBad && !_this.proseInformation.idCourtExecuted && !_this.proseInformation.badInfo) {
              //无风险
              _this.dataList1 = [{ value: 0, name: '社会风险等级' }]
            }
            if (e.data.blackInfo.blackInfo.strcutrueApply == 0 && e.data.blackInfo.blackInfo.expenseApply == 0) {
              _this.isShowEchart = false;
            } else {
              _this.isShowEchart = true;
            }
          }
          else {
            _this.util.toast({ msg: e.msg })
          }
        })
        .catch(error => { });
    },
    changeStatus (val) {
      if (val) {
        return "命中"
      } else {
        return "未命中"
      }
    },
  }

}
</script>
<style scoped>
.check_box {
  position: relative;
  background: #1b1b25;
  top: 0;
}
/* 检测报告 */
.check_box .head_bg {
  background: url("../../assets/img/vip/majorCheck/checkBox_bg.png") no-repeat
    top center;
  background-size: 100% 100%;
  width: 100%;
  height: 2.12rem;
  color: #fff;
  font-family: AlibabaPuHuiTiM;
  font-size: 0.28rem;
  padding: 0.35rem 0.17rem 0rem 0.2rem;
}
.score {
  font-size: 0.34rem;
}
.score_img4,
.score_img1,
.score_img2,
.score_img3 {
  background: url("../../assets/img/vip/check/score_bg1.png") no-repeat top
    center;
  background-size: 100% 100%;
  width: 0.48rem;
  height: 0.24rem;
  position: absolute;
  right: 0.25rem;
}
.score_img2 {
  background: url("../../assets/img/vip/check/score_bg2.png") no-repeat top
    center;
  background-size: 100% 100%;
}
.score_img3 {
  background: url("../../assets/img/vip/check/score_bg3.png") no-repeat top
    center;
  background-size: 100% 100%;
}
.score_img4 {
  background: url("../../assets/img/vip/check/score_bg4.png") no-repeat top
    center;
  background-size: 100% 100%;
}
.userInfo {
  clear: both;
  overflow: hidden;
  position: relative;
  top: 0.3rem;
}
.userInfo li {
  width: 60%;
  display: flex;
  font-size: 0.13rem;
  text-align: left;
  margin-bottom: 0.15rem;
}
.userInfo .userkey {
  color: #979dae;
  margin-right: 0.1rem;
}
.userInfo .userValue {
  color: #fff;
}
.item {
  background: #272733;
  border-radius: 6px;
  margin: 0.15rem 0.1rem;
  color: #979dae;
  font-size: 0.12rem;
  padding: 0.15rem 0.1rem;
}
.comn_title7,
.comn_title1,
.comn_title2,
.comn_title3,
.comn_title4,
.comn_title5,
.comn_title6 {
  /* color: #fff;
  font-size: 0.14rem;
  padding: 0.14rem 0.15rem; */
  background: url("../../assets/img/vip/majorCheck/title_bg1.png") no-repeat top
    center;
  background-size: 100% 100%;
  display: inline-block;
  width: 1.74rem;
  height: 0.22rem;
  margin-bottom: 0.1rem;
}
.comn_title7 {
  background: url("../../assets/img/vip/majorCheck/title_bg7.png") no-repeat top
    center;
  background-size: 100% 100%;
}
.comn_title2 {
  background: url("../../assets/img/vip/majorCheck/title_bg2.png") no-repeat top
    center;
  background-size: 100% 100%;
}
.comn_title3 {
  background: url("../../assets/img/vip/majorCheck/title_bg3.png") no-repeat top
    center;
  background-size: 100% 100%;
}
.comn_title4 {
  background: url("../../assets/img/vip/majorCheck/title_bg4.png") no-repeat top
    center;
  background-size: 100% 100%;
}
.comn_title5 {
  background: url("../../assets/img/vip/majorCheck/title_bg5.png") no-repeat top
    center;
  background-size: 100% 100%;
}
.comn_title6 {
  background: url("../../assets/img/vip/majorCheck/title_bg6.png") no-repeat top
    center;
  background-size: 100% 100%;
}
.line_bg {
  display: inline-block;
  width: 0.04rem;
  height: 0.13rem;
  background: linear-gradient(
    135deg,
    rgba(89, 131, 252, 1) 0%,
    rgba(60, 113, 246, 1) 100%
  );
  position: relative;
  top: 0.015rem;
  margin-right: 0.05rem;
}
.item_con {
  /* padding: 0.15rem 0rem 0.2rem 0rem; */
  clear: both;
  overflow: hidden;
}
.item .box {
  clear: both;
  overflow: hidden;
  display: flex;
  justify-content: space-between;
  padding-left: 0.5rem;
  padding-right: 0.3rem;
}
.flex {
  display: flex;
  justify-content: space-between;
}
.item_key {
  font-size: 0.14rem;
  color: #fff;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 400;
  position: realtive;
}
.item_value {
  font-size: 0.14rem;
  color: #4f8cfa;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
}
.item_value_red {
  color: #ffbd55;
}
.item_info {
  color: #979dae;
  font-size: 0.12rem;
  line-height: 23px;
  background: rgba(32, 32, 44, 1);
  border-radius: 6px;
  padding: 0.1rem;
  margin-top: 0.1rem;
}
.pd {
  padding: 0.13rem 0.1rem;
  line-height: 24px;
}
.color_bg {
  color: #ffe755;
  font-size: 0.12rem;
  background: rgba(255, 162, 73, 0.1);
}
.item_con .bg {
  border-radius: 6px;
}
.flex_box .bg2 {
  background: #1b1b25;
  padding: 0.1rem;
}
.flex_box .bg1 {
  background: #20202c;
  padding: 0.1rem;
}
.item_notice {
  font-size: 0.12rem;
  color: #979dae;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  line-height: 28px;
}
.item .box_con {
  font-size: 0.14rem;
  color: #fff;
  padding-top: 0.4rem;
}
.box_con .appColor {
  color: #4f8cfa;
}
.box_con .red {
  color: #ffd75c;
}
.squire,
.squire1 {
  display: inline-block;
  background: rgba(79, 140, 250, 1);
  border-radius: 2px;
  width: 0.2rem;
  height: 0.1rem;
  margin-right: 0.05rem;
}
.squire1 {
  background: #8ee1ff;
}
.noData_box {
  height: 1rem;
}
.noData,
.noData1 {
  background: url("../../assets/img/vip/check/echarts_noData.png") no-repeat top
    center;
  background-size: 100% 100%;
  width: 0.7rem;
  display: inline-block;
  height: 0.7rem;
  position: relative;
  top: 0.23rem;
}
.noData1 {
  background: url("../../assets/img/vip/majorCheck/echarts_noData1.png")
    no-repeat top center;
  background-size: 100% 100%;
}
.icon,
.icon1 {
  background: url("../../assets/img/vip/majorCheck/icon.png") no-repeat top
    center;
  background-size: 100% 100%;
  width: 0.14rem;
  height: 0.14rem;
  display: inline-block;
  position: relative;
  margin-right: 5px;
  top: 0.01rem;
  left: 0;
}
.icon1 {
  background: url("../../assets/img/vip/majorCheck/icon1.png") no-repeat top
    center;
  background-size: 100% 100%;
}
.progres {
  margin-top: 0.1rem;
}
.pro_item {
  display: flex;
  flex: 1;
  justify-content: space-around;
  font-size: 0.1rem;
  color: #979dae;
  margin-bottom: 0.1rem;
}
.grade {
  color: #5cf0e0;
  font-size: 0.12rem;
}
.grade1 {
  color: #1fcaff;
}
.grade2 {
  color: #336df7;
}
.per_icon1,
.per_icon2 {
  background: url("../../assets/img/vip/majorCheck/per_icon2.png") no-repeat top
    center;
  background-size: 100% 100%;
  display: inline-block;
  width: 0.57rem;
  height: 0.57rem;
  float: left;
}
.per_icon2 {
  background: url("../../assets/img/vip/majorCheck/per_icon1.png") no-repeat top
    center;
  background-size: 100% 100%;
}
.per_con {
  /* display: flex; */
  /* flex: 1; */
  /* justify-content: space-between; */
  padding: 0 0.2rem;
  clear: both;
  overflow: hidden;
  font-size: 0.12rem;
  color: #979dae;
}
.ps {
  position: relative;
  top: 0.1rem;
}
.left_box .title {
  color: #56bdff;
  font-size: 0.14rem;
}
.right_box .title {
  color: #ffe755;
  font-size: 0.14rem;
}
.left_box,
.right_box {
  float: left;
  width: 50%;
}
</style>
<style >
.prg_bg .ivu-progress-bg {
  background-color: #5cf0e0;
}
.prg_bg1 .ivu-progress-bg {
  background-color: #1fcaff;
}
.prg_bg2 .ivu-progress-bg {
  background-color: #336df7;
}

.progress_bg {
  background: url("../../assets/img/vip/majorCheck/progress_bg.png") no-repeat
    top center;
  background-size: 100% 100%;
  width: 100%;
  height: 0.46rem;
  margin: 0.3rem auto;
  position: relative;
}
.progress_icon {
  background: url("../../assets/img/vip/majorCheck/progress_icon.png") no-repeat
    top center;
  background-size: 100% 100%;
  display: inline-block;
  width: 0.1rem;
  height: 0.1rem;
  position: relative;
  left: 12%;
  top: -0.1rem;
}
.pr_32 {
  position: relative;
  left: 32%;
}
.pr_58 {
  position: relative;
  left: 58%;
}
.pr_85 {
  position: relative;
  left: 85%;
}
</style>